export default {
  header: 'Material',
  groupKey: 'material',
  filters: [
    { text: 'Alloy Steel', id: 'alloySteel' },
    { text: 'Aluminum', id: 'aluminum' },
    { text: 'Brass', id: 'brass' },
    { text: 'Carbon Steel', id: 'carbonSteel' },
    { text: 'Cobalt', id: 'cobalt' },
    { text: 'Copper', id: 'copper' },
    { text: 'High Temp Alloy', id: 'highTempAlloy' },
    { text: 'Iron', id: 'iron' },
    { text: 'Lead', id: 'lead' },
    { text: 'Magnesium', id: 'magnesium' },
    { text: 'Micro Alloy', id: 'microAlloy' },
    { text: 'Nickel', id: 'nickel' },
    { text: 'Stainless Steel', id: 'stainlessSteel' },
    { text: 'Steel', id: 'steel' },
    { text: 'Titanium', id: 'titanium' },
    { text: 'Tool Steel', id: 'toolSteel' },
    { text: 'Unspecified', id: 'unspecified' },
  ],
};



// WEBPACK FOOTER //
// ./src/config/searchFilters/materialFilters.js